import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './GroupLeaderboard.css';

const API_BASE_URL = 'https://wholeness-forward.onrender.com/api';

const IndividualLeaderboard = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [search, setSearch] = useState('');
    const [timeframe, setTimeframe] = useState('allTime'); // Default to 'allTime'

    // Fetch Users from API
    useEffect(() => {
        const fetchUsers = async () => {
            setLoading(true);
            setError(null);

            try {
                const response = await axios.get(`${API_BASE_URL}/leaderboard`, {
                    params: { timeframe }
                });                

                console.log("🎯 Individuals Data:", response.data);
                setUsers(response.data);
            } catch (err) {
                setError('Failed to fetch users.');
            } finally {
                setLoading(false);
            }
        };

        fetchUsers();
    }, [timeframe]); // Fetch users whenever the timeframe changes

    // Sort users by weight lost (timeframe-based)
    const sortedUsers = [...users].sort((a, b) => {
        // Use timeframeWeightLost if available, else fall back to allTimeWeightLost
        const aWeightLost = a.timeframeWeightLost === "N/A" ? parseFloat(a.allTimeWeightLost) : parseFloat(a.timeframeWeightLost);
        const bWeightLost = b.timeframeWeightLost === "N/A" ? parseFloat(b.allTimeWeightLost) : parseFloat(b.timeframeWeightLost);
        
        // If "N/A", treat it as 0 for sorting purposes
        const aWeight = isNaN(aWeightLost) ? 0 : aWeightLost;
        const bWeight = isNaN(bWeightLost) ? 0 : bWeightLost;

        return bWeight - aWeight; // Sort in descending order
    });

    // Assign ranks based on sorted order
    const usersWithRank = sortedUsers.map((user, index) => ({
        ...user,
        rank: index + 1, // Rank based on sorted position
    }));

    // Search Filtering (Preserve Rank)
    const filteredUsers = usersWithRank.filter(user =>
        user?.username?.toLowerCase().includes(search.toLowerCase()) ||
        user?.fullName?.toLowerCase().includes(search.toLowerCase())
    );

    if (loading) return <div className="loading">🔄 Loading leaderboard...</div>;
    if (error) return <div className="error-message">❌ {error}</div>;

    return (
        <div className="group-page-container">
            <img src="/images/weighlogo.png" alt="WeighForward Logo" className="leader-logo" />
            <h1 className="group-title">WeighForward Leaderboard</h1>
            

           
            <div className="micro-void"></div>



            <div className="leaderboard-section">
                <h3>Individual Rankings</h3>

            {/* Timeframe Dropdown */}
                      <div className="timeframe-selector">
                <label>Show data for:</label>
                <select value={timeframe} onChange={(e) => setTimeframe(e.target.value)}>
                    <option value="allTime">All Time</option>
                    <option value="week">This Week</option>
                    <option value="month">This Month</option>
                    <option value="year">This Year</option>
                </select>
            </div>

              {/* Search Bar */}
              <input
                type="text"
                placeholder="Search by username"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="search-bar"
            />

                <table className="mini-leaderboard-table">
                    <thead>
                        <tr>
                            <th>Rank</th>
                            <th>Username</th>
                            <th>Weight Lost (lbs)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredUsers.length === 0 ? (
                            <tr><td colSpan="3">❌ No data available</td></tr>
                        ) : (
                            filteredUsers.map((user) => (
                                <tr key={user.username}>
                                    <td># {user.rank}</td> {/* Displaying Rank */}
                                    <td>{user.username}</td> {/* Displaying username */}
                                    <td className={
                                        parseFloat(user.timeframeWeightLost === "N/A" ? user.allTimeWeightLost : user.timeframeWeightLost) > 0 ? "loss" :
                                        parseFloat(user.timeframeWeightLost === "N/A" ? user.allTimeWeightLost : user.timeframeWeightLost) < 0 ? "gain" :
                                        "neutral"
                                    }>
                                        {/* Displaying the weight lost with fallback if N/A */}
                                        {user.timeframeWeightLost === "N/A" ? `${user.allTimeWeightLost} lbs` : `${user.timeframeWeightLost} lbs`}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

   
            <div className="micro-void"></div>
            {/* 🔙 Back to Main Leaderboard */}
            <Link to="/leaderboard" className="leaderboard-link">← Back to Main Leaderboard</Link>
        </div>
    );
};


export default IndividualLeaderboard;
